"use client";

import { MapPin, Phone } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Ubicacion() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section ref={sectionRef} className="relative w-full py-16 bg-background overflow-hidden">
      <div className="container mx-auto px-4">
        {}
        

        {}
        <div ref={cardRef} className={`mt-8 flex justify-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          
        </div>
      </div>
    </section>;
}